module.exports = __webpack_public_path__ + "media/images/iconAccount-55561ec09f660ddc5c2303dd6a8a4d1a.png";